module.exports = __webpack_public_path__ + "img/task4_icon1.38c63b87.png";